import { initializeApp } from "firebase/app";
import {getFirestore} from "@firebase/firestore";
import { getDatabase } from "firebase/database";
import {getStorage} from "firebase/storage"
// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object
const firebaseConfig = {
    // ...
    // The value of `databaseURL` depends on the location of the database
    apiKey: "AIzaSyBjexCWv09OCbMnQGGlt17O19uII5Vm6S8",
    authDomain: "pqeconference.firebaseapp.com",
    databaseURL: "https://pqeconference-default-rtdb.firebaseio.com",
    projectId: "pqeconference",
    storageBucket: "pqeconference.appspot.com",
    messagingSenderId: "1029308770761",
    appId: "1:1029308770761:web:c6f1778b1444301b23a018",
    measurementId: "G-1GKJBQL621"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);


// Initialize Realtime Database and get a reference to the service
export const db = getFirestore(app)
export const stor = getStorage(app);
